<div class="container">
    <div class="title-container">
        <h1>Site Management</h1>
    </div>
    <app-role-picker  [allRoles]="allRoles" [stream]="stream"></app-role-picker>
    <button mat-raised-button class="save-button" (click)="save()">Save</button>
</div>
